export default function Loader() {
    return (
        <div className="fixed inset-0 h-full w-full bg-white/70 flex items-center justify-center z-10 rounded-sm">
            <div className="w-10 h-10 border-2 border-muted-color border-t-body-color rounded-full animate-spin" />
        </div>
    )
}
